/* Hide when every direct child is empty.

   The naive ".collapse:has(> :empty)" means "has AT LEAST ONE empty child",
   which would hide the box even when other children have content.

   Double negation — :not(:has(> :not(:empty))) — inverts the logic:
   "there is no child that is non-empty" ≡ "all children are empty".
   CSS has no :has-every pseudo-class, so this is the idiomatic workaround.
*/

.collapse:not(:has(> :not(:empty))) {
    display: none !important;
}
